import { createApp } from "vue";
import "./style.css";
import App from "./App.vue";
import router from "./router";
import { installAnalytics } from "./lib/analytics";

installAnalytics(router);

createApp(App).use(router).mount("#app");

window.addEventListener(
  "load",
  () => {
    if ("serviceWorker" in navigator) {
      import("virtual:pwa-register").then(({ registerSW }) =>
        registerSW({ immediate: false }),
      );
    }
  },
  { once: true },
);
